import { notification } from "antd";
import PasswordField from "components/common/Password/PasswordField";
import { Form, Formik } from "formik";
import React, { useCallback, useState } from "react";
import localStorage from "utils/LocalStorage";
import { resetPasswordValidation } from "utils/validations";

const SecurityComponent = ({ resetUserPassword }) => {
  const [passwordVisibility, setPasswordVisibility] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });
  const [loading, setLoading] = useState(false);

  const toggleVisibility = useCallback(
    (field) => {
      setPasswordVisibility((prev) => ({
        ...prev,
        [field]: !prev[field],
      }));
    },
    [setPasswordVisibility],
  );

  const handleFormSubmit = useCallback(
    async (values, { setErrors, resetForm }) => {
      try {
        if (values?.oldPassword === values?.newPassword) {
          notification["warning"]({ message: "New password cannot be same as old password!" });
          return;
        }
        setLoading(true);

        const { value } = await resetUserPassword({
          currentPassword: values.oldPassword,
          newPassword: values.newPassword,
        });

        if (value?.status) {
          notification["success"]({ message: value?.message });
          localStorage.setItem("authToken", value?.token);
          resetForm();
        } else {
          notification["error"]({ message: value?.message });
          setErrors({ submit: value?.message });
        }
        setLoading(false);
      } catch (error) {
        console.error("error occured at reset password", error);
        notification["error"]({ message: error?.message });
        setLoading(false);
      }
    },
    [resetUserPassword],
  );

  return (
    <div className="border-block--op">
      <div>
        <h4 className="title-sm-t">Update Password</h4>
      </div>
      <Formik
        initialValues={{
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        }}
        validationSchema={resetPasswordValidation}
        onSubmit={handleFormSubmit}
      >
        {({ errors, touched }) => (
          <Form>
            <PasswordField
              name="oldPassword"
              placeholder="Current Password"
              isVisible={passwordVisibility.oldPassword}
              toggleVisibility={() => toggleVisibility("oldPassword")}
              errors={errors}
              touched={touched}
            />
            <PasswordField
              name="newPassword"
              placeholder="New Password"
              isVisible={passwordVisibility.newPassword}
              toggleVisibility={() => toggleVisibility("newPassword")}
              errors={errors}
              touched={touched}
            />
            <PasswordField
              name="confirmPassword"
              placeholder="Confirm New Password"
              isVisible={passwordVisibility.confirmPassword}
              toggleVisibility={() => toggleVisibility("confirmPassword")}
              errors={errors}
              touched={touched}
            />
            <p>
              Note: <br />
              Choose a strong password and don't reuse it for other accounts. <br />
              You maybe signed out of your account on some devices <br />
            </p>
            {/* {errors.submit && <div className="err invalid-feedback">{errors.submit}</div>} */}
            <div className="button-container">
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SecurityComponent;
